<powerbi-report
  [embedConfig]="reportConfig"
  [cssClassName]="reportClass"
  [phasedEmbedding]="phasedEmbeddingFlag"
  [eventHandlers]="eventHandlersMap"
>
</powerbi-report>

<div *ngIf="!isEmbedded" class="display-message">
  <label>{{ displayMessage }}</label>
</div>
